/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ModalProgressBar } from '../../../../../../_metronic/_partials/controls';
import * as actions from '../../../_redux/stocks/stocksActions';
import { useStocksUIContext } from '../StocksUIContext';

export function StockDeleteDialog({ id, show, onHide }) {
  const stocksUIContext = useStocksUIContext();
  const stocksUIProps = useMemo(() => {
    return {
      setIds: stocksUIContext.setIds,
      queryParams: stocksUIContext.queryParams,
    };
  }, [stocksUIContext]);

  // Stocks Redux state
  const dispatch = useDispatch();
  const intl = useIntl();
  const titleText = intl.formatMessage({ id: 'STOCK.CONFIRM.TITLE' });
  const questionText = intl.formatMessage({
    id: 'STOCK.CONFIRM.DELETE.QUESTION',
  });
  const deleteButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.DELETE',
  });
  const cancelButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.CANCEL',
  });
  const loadingText = intl.formatMessage({
    id: 'STOCK.CONFIRM.DELETE.LOADING',
  });
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.stocks ? state.stocks.actionsLoading : false,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!id) {
      onHide();
    }
  }, [id]);

  useEffect(() => {}, [isLoading, dispatch]);

  const deleteStock = () => {
    dispatch(actions.deleteStock(id)).then(() => {
      dispatch(actions.fetchStocks(stocksUIProps.queryParams));
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      {isLoading && <ModalProgressBar variant='query' />}
      <Modal.Header closeButton>
        <Modal.Title id='Stockexample-modal-sizes-title-lg'>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>
            {' '}
            <b>{id}</b> {questionText}
          </span>
        )}
        {isLoading && <span>{loadingText}</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'
          >
            {cancelButtonText}
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteStock}
            className='btn btn-primary btn-elevate'
          >
            {deleteButtonText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
